(function() {
    'use strict';
    /*
     * Copyright (c) 2019 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .controller('CampaignFormCtrl', CampaignFormCtrl);

    CampaignFormCtrl.$inject = ['_', '$scope', '$filter', 'IhhModalItemChooser'];

    /*
     * A controller for the campaign form directive.
     */
    function CampaignFormCtrl(_, $scope, $filter, IhhModalItemChooser) {
        var vm = this;

        vm.statuses = ['Draft', 'Active', 'Active (Default)', 'Closed'];
        vm.activeStatus = vm.statuses[1];
        vm.activeDefaultStatus = vm.statuses[2];
        vm.setStatus = setStatus;
        vm.getStatus = getStatus;
        vm.getClinicGroupShared = getClinicGroupShared;
        vm.setClinicGroupShared = setClinicGroupShared;
        vm.formatYesNo = formatYesNo;

        vm.chooseClinicSpecialty = chooseClinicSpecialty;
        vm.removeClinicSpecialty = removeClinicSpecialty;

        vm.state = vm.state ? vm.state : {};
        vm.state.campaign = vm.state.campaign ? vm.state.campaign : {};
        vm.state.campaign.status = vm.state.campaign.status ? vm.state.campaign.status : vm.statuses[0];
        vm.state.campaignTemp = vm.state.campaignTemp ? vm.state.campaignTemp : {};
        vm.state.campaignTemp.status = vm.state.campaignTemp.status ? vm.state.campaignTemp.status : vm.statuses[0];

        vm.clinicGroupSharedValues = [true];

        $scope.$watch('vm.state.campaign', function(newValue) {
            if (newValue.status === 'active' && newValue.isDefault) {
                setStatus(vm.activeDefaultStatus);
            }
            else {
                setStatus(newValue.status);
            }

            vm.clinicGroupSharedValues = newValue.clinicGroupShared ? [true] : [true, false];

        });

        function getModel() {
            if (vm.editFlag) {
                return vm.state.campaignTemp;
            }
            else {
                return vm.state.campaign;
            }
        }

        function setStatus (status) {
            // This is Active (default)
            if (status === vm.activeDefaultStatus) {
                getModel().status = vm.activeStatus;
                getModel().isDefault = true;
            }
            // Otherwise it is not the default
            else {
                getModel().status = $filter('uppercaseFirst')(status);
                getModel().isDefault = false;
            }
        }

        function getStatus () {
            // Handle active default as a special case
            var upperStatus = $filter('uppercaseFirst')(getModel().status);
            return upperStatus === vm.activeStatus && getModel().isDefault
                ? vm.activeDefaultStatus
                : upperStatus;
        }

        function getClinicGroupShared() {
            return getModel().clinicGroupShared;
        }

        function setClinicGroupShared(flag) {
            getModel().clinicGroupShared = flag;
        }

        /*
         * Formats a values as Yes or No based on truthiness.
         */
        function formatYesNo(value) {
            return value ? 'Yes' : 'No';
        }

        /*
         * Displays a picker to allow the user to add a clinic specialty to the campaign.
         */
        function chooseClinicSpecialty() {
            if (vm.clinicSpecialtyConfig) {
                vm.state.campaignTemp.clinicSpecialties = vm.state.campaignTemp.clinicSpecialties || [];
                vm.clinicSpecialtyConfig.setSuppressedItems = vm.state.campaignTemp.clinicSpecialties;
                vm.clinicSpecialtyConfig.setSelectedFn(function(item) {
                    vm.state.campaignTemp.clinicSpecialties.push(item);
                });

                vm.clinicSpecialtyConfig.maintainState($scope);
                IhhModalItemChooser.open(vm.clinicSpecialtyConfig);
            }
        }

        /*
         * Removes the given clinic specialty from the campaign.
         */
        function removeClinicSpecialty(clinicSpecialty) {
            if (vm.state.campaignTemp && vm.state.campaignTemp.clinicSpecialties) {
                _.remove(vm.state.campaignTemp.clinicSpecialties, function(item) {
                    return clinicSpecialty.id === item.id;
                });
            }
        }
    }
})();